import { Component, computed, OnDestroy } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { LiveAssetManagementService, RoleService } from '@rvi/asset-modules';
import { map, of } from 'rxjs';

@Component({
    selector: 'app-live-asset-page',
    templateUrl: './live-asset-page.component.html',
    styleUrl: './live-asset-page.component.scss',
    standalone: false
})
export class LiveAssetPageComponent implements OnDestroy {
  public createLiveAssetDisabled = computed(() => this.isDetailsPage() || !this.canCreateLiveAsset);
  private isDetailsPage = toSignal(this.liveAssetManagementService.pageState$.pipe(map(page => page === "LiveAssetPage")));
  private canCreateLiveAsset = false;

  constructor(private liveAssetManagementService: LiveAssetManagementService, private assetModuleRoleService: RoleService) {
    this.canCreateLiveAsset = this.assetModuleRoleService.canI('CreateLiveAsset');
  }
  
  ngOnDestroy(): void {
    this.liveAssetManagementService.goToLiveAssetTable();
  }

  addLiveAsset() {
    this.liveAssetManagementService.goToCreateLiveAsset();
  }
}
